// extracted by mini-css-extract-plugin
export default {"users":"Users_users__SMbTW","tabla":"Users_tabla__uvppg"};